import { Button, IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ReactNode } from 'react';
import { AppTheme } from 'src/themes/muiTheme';

interface AdditionalInsuredActionButtonProps {
  icon: ReactNode;
  children: ReactNode;
  onClick: () => void;
  variant: 'add' | 'delete';
}

const additionalInsuredActionButtonStyles = {
  shared: {
    padding: '8px 11px',
  },
  mobile: {
    borderRadius: '4px',
    backgroundColor: 'transparent !important',
  },
};

export function AdditionalInsuredActionButton({
  children,
  icon,
  onClick,
  variant,
}: AdditionalInsuredActionButtonProps) {
  const isMobile = useMediaQuery<AppTheme>((theme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    return theme.breakpoints.down(mobileMaxSize);
  });

  return (
    <>
      {isMobile ? (
        <IconButton
          sx={{
            ...additionalInsuredActionButtonStyles.shared,
            ...additionalInsuredActionButtonStyles.mobile,
          }}
          onClick={onClick}
          color="primary"
        >
          {icon}
        </IconButton>
      ) : (
        <Button
          sx={additionalInsuredActionButtonStyles.shared}
          onClick={onClick}
          startIcon={icon}
          color={variant === 'delete' ? 'error' : undefined}
        >
          {children}
        </Button>
      )}
    </>
  );
}
